<button type="button" class="toggle-button" (click)="click()">
  <div class="row d-flex">
    <div class="col justify-content-center" *ngIf="buttonType!=ToggleButtonType.TEXT" [ngClass]="buttonType===ToggleButtonType.ICON?'ps-4 pe-4':'pe-0'">
      <ng-container [ngSwitch]="iconStyle">
        <ng-container *ngSwitchCase="ToggleButtonIconStyle.ADD_REMOVE">
          <mat-icon *ngIf="!toggled">add_circle_outline</mat-icon>
          <mat-icon *ngIf="toggled">remove_circle_outline</mat-icon>
        </ng-container>
      </ng-container>
    </div>
    <div class="col justify-content-center pb-2" *ngIf="buttonType!=ToggleButtonType.ICON" [ngClass]="buttonType===ToggleButtonType.TEXT?'ps-4 pe-4':''">{{ (toggled ? toggledText : unToggledText) |
      translate }}</div>
  </div>
</button>
